<!--  -->
<template>
  <div class="edition_box">
    <div class="edition_text">
      <h2 class="tewr">版本管理</h2>
    </div>

    <div class="awerwa">
      <div class="awe_onbox">
        <el-input v-model="pageoneInfo.keyword" style="width: 300px;margin: 0 20px;" placeholder="请输入小程序名称/appid" />
        <el-button type="primary" icon="el-icon-search" @click="serawed">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh" @click="reset">重置</el-button>
        <el-button type="success" style="margin-left: 20px;" @click="updatadaswrsadw">线上版本刷新</el-button>
        <el-button type="warning" style="margin-left: 20px;" @click="openVersionRevert">版本回退</el-button>
      </div>
      <div class="editionr_box">
        <h3 style="font-weight: 400;line-height: 0;">线上版本</h3>
        <div v-if="onlinelist.length == 0" class="noparwr">你暂无提交审核的版本或者版本已发布上线</div>
        <div v-for="itemsaw,index in onlinelist" v-else :key="index" class="online_box" :class="{ 'online_boxline': index !== onlinelist.length - 1}">
          <div class="flexe_box">
            <!-- 盒子1 -->
            <div>
              <div class="version">版本号</div>
              <div class="versionnum">{{ itemsaw.user_version }}</div>
              <div class="toexamine">
                <div>{{ itemsaw.auditStatusText }}</div>
              </div>
              <el-button v-if="itemsaw.audit_status == 1" style="margin-top:5px" type="success" size="mini" @click="errordialog(itemsaw.reason)">审核失败原因</el-button>
            </div>
            <!-- 盒子2 -->
            <div class="boxrws">
              <div class="publisher">
                <div class="version">小程序/appid</div>
                <div class="vewaer" style="margin-left:30px">{{ itemsaw.account_name }}/{{ itemsaw.miniprogram_app_id }}</div>
              </div>
              <div class="publisher">
                <div class="version">发布时间</div>
                <div class="vewaer" style="margin-left:50px">{{ itemsaw.createTimeText }}</div>
              </div>
              <div class="publisher">
                <div class="version">项目备注</div>
                <div class="vewaer" style="margin-left:50px">{{ itemsaw.user_desc }}</div>
              </div>
            </div>
          </div>
          <!-- 盒子3 -->
          <div>
            <el-button v-if="itemsaw.release_status == 1" type="success" disabled>已发布</el-button>
            <el-button v-else type="success" :disabled="itemsaw.audit_status==8 || itemsaw.audit_status==1 || itemsaw.audit_status==2 || itemsaw.audit_status==3 || itemsaw.audit_status==4" @click="sendsubmitauditr(itemsaw.id)">发布</el-button>
            <el-button v-if="itemsaw.release_status != 1" type="success" :disabled="itemsaw.audit_status==8 || itemsaw.audit_status==1 || itemsaw.audit_status==2 || itemsaw.audit_status==3 || itemsaw.audit_status==4" @click="nosendsubmitauditr(itemsaw.id)">不发布</el-button>
            <el-button type="success" :disabled="itemsaw.audit_status==0 || itemsaw.audit_status==2 || itemsaw.audit_status==3 || itemsaw.audit_status==4" @click="submitr(itemsaw.id)">提交</el-button>
            <!-- itemsaw.audit_status==1 提交之前的判断-->
            <el-button type="success" @click="lookma(itemsaw)">查看体验版二维码</el-button>
            <el-button v-if="itemsaw.audit_status == 2" type="danger" @click="chehui(itemsaw)">撤回</el-button>
          </div>
        </div>
      </div>
      <pagination-right
        :total="onetotal"
        :current-page="pageoneInfo.page"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>

    <div class="awerwa" style="margin-top:50px">
      <el-button type="success" style="margin-bottom:10px" @click="updatadaswr">审核版本刷新</el-button>
      <div class="editionr_box">
        <h3 style="font-weight: 400;line-height: 0;">模板库/审核版本</h3>
        <div v-if="templatedata.length == 0" class="noparwr">你暂无提交审核的版本或者版本已发布上线</div>
        <div v-for="itemr,index in templatedata" v-else :key="index" class="online_box" :class="{ 'online_boxline': index !== templatedata.length - 1}">
          <div class="flexe_box">
            <!-- 盒子1 -->
            <div>
              <div class="version">版本号</div>
              <div class="versionnum">{{ itemr.user_version }}</div>
              <div class="toexamine">
                <div>{{ itemr.auditStatusText }}</div>
              </div>
            </div>
            <!-- 盒子2 -->
            <div class="boxrws">
              <div class="publisher">
                <div class="version">模板ID</div>
                <div class="vewaer" style="margin-left:50px">{{ itemr.template_id }}</div>
              </div>
              <div class="publisher">
                <div class="version">发布时间</div>
                <div class="vewaer" style="margin-left:35px">{{ itemr.createTimeText }}</div>
              </div>
              <div class="publisher">
                <div class="version">项目备注</div>
                <div class="vewaer" style="margin-left:35px">{{ itemr.user_desc }}</div>
              </div>
            </div>
          </div>
          <!-- 盒子3 -->
          <div>
            <!-- :disabled="itemr.auditStatus != 3" -->
            <!-- <el-button v-if="itemr.template_type == 0" type="success" @click="uploadcode(itemr)">上传代码并生成体验版</el-button>
            <el-button v-else type="success" :disabled="itemr.audit_status != 3 " @click="uploadcode(itemr)">上传代码并生成体验版</el-button> -->
            <!-- 最新 没有去掉条件前 -->
            <!-- <el-button v-if="itemr.template_type == 0 && itemr.audit_status == 0 && itemr.show_to_upload == true" type="success" @click="uploadcode(itemr)">上传代码并生成体验版</el-button> -->
            <el-button type="success" @click="uploadcode(itemr)">上传代码并生成体验版</el-button>
            <el-button type="success" @click="delecter(itemr.id)">删除</el-button>
          </div>
        </div>

        <!-- <div class="noparwr">你暂无提交审核的版本或者版本已发布上线</div> -->
        <pagination-right
          :total="twototal"
          @size-change="fetchPageSizetwo"
          @current-change="fetchCurrentPagetwo"
        />
      </div>

    </div>

    <div class="awerwa" style="margin-top:50px">
      <el-button type="success" style="margin-bottom:10px" @click="updatasw">开发版本刷新</el-button>
      <div class="editionr_box">
        <h3 style="font-weight: 400;line-height: 0;">草稿箱/开发版本</h3>
        <div v-if="draftsdata.length == 0" class="noparwr">你暂无提交审核的版本或者版本已发布上线</div>
        <div v-for="item,index in draftsdata" v-else :key="index" class="online_box" :class="{ 'online_boxline': index !== draftsdata.length - 1}">
          <div class="flexe_box">
            <!-- 盒子1 -->
            <div>
              <div class="version">版本号</div>
              <div class="versionnum">{{ item.user_version }}</div>
              <!-- <div class="experience">
                <div style="margin-right:5px">体验版</div>
                <i class="icon_code_qrcode" />
              </div> -->
            </div>
            <!-- 盒子2 -->
            <div class="boxrws">
              <div class="publisher">
                <div class="version">发布者</div>
                <div class="vewaer" style="margin-left:50px">暂无发布者</div>
              </div>
              <div class="publisher">
                <div class="version">发布时间</div>
                <div class="vewaer" style="margin-left:35px">{{ item.createTimeText }}</div>
              </div>
              <div class="publisher">
                <div class="version">项目备注</div>
                <div class="vewaer" style="margin-left:35px">{{ item.user_desc }}</div>
              </div>
            </div>
          </div>
          <!-- 盒子3 -->
          <div>
            <el-button type="success" @click="addtemplatelibrary(item.id)">添加到模板库</el-button>
          </div>
        </div>

        <!-- <div class="noparwr">你暂无提交审核的版本或者版本已发布上线</div> -->

      </div>

    </div>

    <el-dialog
      title="选择小程序"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      width="35%"
    >
      <choosewechat ref="bandwechatwer" @callback="callback" />
    </el-dialog>
    <el-dialog
      title="体验版二维码"
      :visible.sync="dialogVisiblelook"
      width="30%"
    >
      <div style="text-align: center;">
        <img v-if="maimg" :src="maimg" style="width:200px;height:200px" alt="">
      </div>

    </el-dialog>
    <el-dialog
      title="审核失败原因"
      :visible.sync="errordialewr"
      width="30%"
    >
      <div>
        <div v-html="errorname" />
      </div>
    </el-dialog>
    <el-dialog
      title="上传失败信息"
      :visible.sync="erroraccount"
      width="60%"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <errorlist ref="errorlistview" />
    </el-dialog>
    <el-dialog
      title="版本回退"
      :visible.sync="versionRevertVisible"
      width="50%"
      :destroy-on-close="true"
      @closed="onVersionRevertClosed"
    >
      <version-revert ref="versionRevertRef" @success="onVersionRevertSuccess" />
    </el-dialog>
  </div>
</template>

<script>
import { getdraftslist, adddraftstemplate, templatelibrarylist, templatedelete, experiencelist, submitaudit, sendsubmitaudit, nosendsubmitaudit, updataasycdrafts, updataayscTemplates, updatarefreshauditSt, gettemplater, chehuing } from '@/api/sourceMaterial.js'
import choosewechat from './components/choosewechat.vue'
import versionRevert from './components/versionRevert.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import errorlist from '../redEnvelopeActivity/components/errorlist.vue'
export default {
  components: {
    choosewechat,
    versionRevert,
    PaginationRight,
    errorlist
  },
  data() {
    return {
      pageInfo: {
        page: 1,
        pageSize: 10
      },
      pageoneInfo: { // 线上版本分页
        page: 1,
        pageSize: 10,
        keyword: ''
      },
      pagetwoInfo: { // 模板库版本分页
        page: 1,
        pageSize: 10
      },
      draftsdata: [],
      templatedata: [],
      onlinelist: [],
      dialogVisible: false,
      dialogVisiblelook: false,
      maimg: '',
      errordialewr: false,
      errorname: '',

      onetotal: null, // 线上版本总页数
      twototal: null, // 模板库/审核版本总页数
      erroraccount: false,
      versionRevertVisible: false
    }
  },
  created() {
    this.getdrafts()
    this.templatelist()
    this.geteasw()
  },
  mounted() {

  },
  methods: {
    // 获取草稿箱
    async getdrafts() {
      const data = await getdraftslist(this.pageInfo)
      this.draftsdata = data.data.list
      console.log('data', data)
    },
    // 添加到模板库
    addtemplatelibrary(id) {
      this.$confirm('确定添加到模板库吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        adddraftstemplate({
          id: id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '添加成功!'
          })
          Promise.all([
            this.updatadaswr(),
            this.getdrafts(),
            this.templatelist()
          ]).then(res => {
            console.log(res)
            // setTimeout(() => {
            //   this.hideLoading()// 延时结束loading
            // }, 800)
          })
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    // 获取模板列表
    async templatelist() {
      const data = await templatelibrarylist(this.pagetwoInfo)
      this.templatedata = data.data.list
      this.twototal = data.data.total
      console.log('data2', data)
    },
    // 删除
    delecter(id) {
      console.log('666')
      this.$confirm('确定要删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        templatedelete({
          id: id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.templatelist()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    // 上传代码并生成体验版
    uploadcode(item) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.bandwechatwer.send(item)
      })
    },
    callback(item) {
      this.dialogVisible = false
      this.templatelist()
      this.geteasw()
      // eslint-disable-next-line eqeqeq
      if (item.length != 0) {
        this.erroraccount = true
        this.$nextTick(() => { // 请求成功之后，在这里执行
          this.$refs.errorlistview.send(item)
        })
      }
      console.log('item', item)
    },
    // 获取线上版本列表
    async geteasw() {
      const data = await experiencelist(this.pageoneInfo)
      this.onlinelist = data.data.list
      this.onetotal = data.data.total
      console.log('data1', data)
    },
    // 提交代码
    submitr(id) {
      this.$confirm('确定要提交吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        submitaudit({
          id: id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '提交成功!'
          })
          this.geteasw()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    // 发布
    sendsubmitauditr(id) {
      this.$confirm('确定要发布吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        sendsubmitaudit({
          id: id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '提交成功!'
          })
          this.geteasw()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    // 不发布
    nosendsubmitauditr(id) {
      this.$confirm('确定不要发布吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        nosendsubmitaudit({
          id: id,
          type: 2
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '提交成功!'
          })
          this.geteasw()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    // 开发版本刷新
    async updatasw() {
      const data = await updataasycdrafts()
      this.$message({
        type: 'success',
        message: '刷新成功!'
      })
      this.getdrafts()
      console.log('data', data)
    },
    // 审核版本刷新
    async updatadaswr() {
      const data = await updataayscTemplates()
      this.$message({
        type: 'success',
        message: '刷新成功!'
      })
      this.templatelist()
      console.log('data', data)
    },
    // 线上版本刷新
    async updatadaswrsadw() {
      const data = await updatarefreshauditSt()
      this.$message({
        type: 'success',
        message: '刷新成功!'
      })
      this.geteasw()
      console.log('data', data)
    },
    async lookma(item) {
      this.dialogVisiblelook = true
      const data = await gettemplater({
        id: item.id
      })
      console.log('data', data)
      this.maimg = data.data.qrcode
    },
    errordialog(item) {
      this.errordialewr = true
      this.errorname = item
    },
    // 线上版本分页
    fetchPageSize(e) {
      this.pageoneInfo.pageSize = e
      this.geteasw()
    },
    fetchCurrentPage(e) {
      this.pageoneInfo.page = e
      this.geteasw()
    },
    // 模板库版本分页
    fetchPageSizetwo(e) {
      this.pagetwoInfo.pageSize = e
      this.templatelist()
    },
    fetchCurrentPagetwo(e) {
      this.pagetwoInfo.page = e
      this.templatelist()
    },
    serawed() {
      this.pageoneInfo.page = 1
      this.geteasw()
    },
    // 重置
    reset() {
      this.pageoneInfo = {
        page: 1,
        pageSize: 10,
        keyword: ''
      }
      this.geteasw()
    },
    openVersionRevert() {
      this.versionRevertVisible = true
      this.$nextTick(() => {
        this.$refs.versionRevertRef.init()
      })
    },
    onVersionRevertSuccess() {
      this.versionRevertVisible = false
      this.updatadaswrsadw()
    },
    onVersionRevertClosed() {
      this.versionRevertVisible = false
    },
    chehui(item) {
      console.log('item', item)
      this.$confirm('确定要撤回吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        chehuing({
          app_id: item.miniprogram_app_id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '提交成功!'
          })
          this.updatadaswrsadw()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.edition_box{
  padding: 20px;
}
.tewr{
  font-weight: 400;
  font-style: normal;
}
.online_box{
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
}
.online_boxline {
  border-bottom: 1px solid #e7e7eb;
  padding-bottom: 8px;
}
.flexe_box{
    display: flex;
}
.awerwa{
  padding:0px 60px;
}
.editionr_box{
    padding: 20px 40px 20px 40px;
    /* border: 1px solid #ccc; */
    box-shadow: 0 0px 2px rgb(150 150 150 / 30%);
    box-sizing: border-box;
    border-radius: 4px;
}
.boxrws{
  margin-left: 50px;
}
.version{
  font-size: 14px;
  color: #9a9a9a;
}
.versionnum{
  font-size: 22px;
  color: #353535;
  margin-top: 10px;
}
.publisher{
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.vewaer{
    color: #353535;
    font-size: 14px;
}
.noparwr{
    text-align: center;
    padding: 50px 0px;
    font-size: 14px;
    color: #9a9a9a;
}
.icon_code_qrcode{
    background: url('https://res.wx.qq.com/mmbizwxampnodelogicsvr_node/dist/images/index_z_@all_006ec1.png') 0 -0px no-repeat;
    width: 12px;
    height: 12px;
    vertical-align: middle;
    display: inline-block;
    line-height: 300px;
    overflow: hidden;
    margin-top: -2px;
}
.experience{
  display: flex;
  align-items: center;
  border: 1px solid #00ACFF;
  color: #00ACFF;
  font-size: 13px;
  padding-top: 2px;
  padding-left: 2px;
  padding-right: 2px;
  margin-top: 5px;
  cursor: pointer;
}
.toexamine{
  cursor: pointer;
  color: rgb(255, 145, 41);
  border: 1px solid rgb(255, 145, 41);
  font-size: 13px;
  margin-top: 5px;
  text-align: center;
  padding-top: 2px;

}
.awe_onbox{
  display: flex;
  /* align-items: center; */
}
</style>
